(function(window, angular){'use strict';

var ngModule = angular.module('pp.services.gbGroup', ['pp.services.core', 'pp.services.investor']);

var ADDRESS_FIND_ENDPOINT = '/feapi/r1/lookup/address';
var ADDRESS_RESOLVE_ENDPOINT = '/feapi/r1/lookup/address/';
var KYC_INDIVIDUAL_ENDPOINT = '/investor/kyc-primary';
var KYC_BUSINESS_ENDPOINT = '/investor/kyc-business';
var KYC_SECONDARY_ENDPOINT = '/investor/kyc-secondary';

var POSTCODE_REGEXP = /^(([gG][iI][rR] {0,}0[aA]{2})|((([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y]?[0-9][0-9]?)|(([a-pr-uwyzA-PR-UWYZ][0-9][a-hjkstuwA-HJKSTUW])|([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y][0-9][abehmnprv-yABEHMNPRV-Y]))) {0,}[0-9][abd-hjlnp-uw-zABD-HJLNP-UW-Z]{2}))$/i;

/**
 * @ngdoc service
 * @name gbGroupService
 *
 * @description
 * Provides methods to invoke address lookup and KYC endpoints.
 */
ngModule.service('gbGroupService', ['$http', '$q', 'investorService', 'ppUtil', function ($http, $q, investorService, ppUtil) {

    var promiseCache = {};

    var api = {};

    function formatDate(date) {
        return date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear();
    }

    /**
     * @ngdoc method
     * @name gbGroupService#findAddresses
     *
     * @description
     * Step 1: Given a postcode query, returns address suggestions from Ideal Postcodes.
     * Each suggestion has an `id` and `suggestion` (display text).
     *
     * Promises are cached per query. Invalid postcodes are validated before the request.
     *
     * @param {string} postcode
     * @returns {Promise} resolves with [{id, suggestion}, ...]
     */
    api.findAddresses = function (postcode) {

        var cacheKey = 'find.' + postcode;

        if (!promiseCache[cacheKey]) {

            var defer = $q.defer();
            promiseCache[cacheKey] = defer.promise;

            if (!api.validatePostcode(postcode)) {
                defer.reject({
                    reason: 'gbGroup.error.postcode.invalid'
                });
            } else {
                $http.post(ADDRESS_FIND_ENDPOINT, {
                    query: postcode.toUpperCase()
                }).then(function (response) {
                    var data = response.data || [];
                    if (data.length) {
                        defer.resolve(data);
                    } else {
                        defer.reject({
                            reason: 'gbGroup.error.noMatches'
                        });
                    }
                }, function () {
                    delete promiseCache[cacheKey];
                    defer.reject({
                        reason: 'gbGroup.error.unexpected'
                    });
                });
            }
        }
        return promiseCache[cacheKey];
    };

    /**
     * @ngdoc method
     * @name gbGroupService#resolveAddress
     *
     * @description
     * Step 2: Given a suggestion ID, resolves the full address.
     *
     * @param {string} id - address suggestion ID from findAddresses
     * @returns {Promise} resolves with {lineOne, lineTwo, lineThree, townCity, region, postcode, country}
     */
    api.resolveAddress = function (id) {
        return $http.get(ADDRESS_RESOLVE_ENDPOINT + encodeURIComponent(id)).then(function (response) {
            return response.data;
        }, function () {
            return $q.reject({
                reason: 'gbGroup.error.unexpected'
            });
        });
    };

    /**
     * @ngdoc method
     * @name gbGroupService#submitKyc
     *
     * @description
     * Submits primary or business kyc data to the gbGroup service.
     *
     * @param {string} type
     * @param {object} data
     * @returns {Promise}
     */
    api.submitKyc = function (type, data) {

        var endpoint = type === 'individual' ? KYC_INDIVIDUAL_ENDPOINT : KYC_BUSINESS_ENDPOINT;

        data.gender = 'UNKNOWN';

        // @todo post-conversion-phase-2 over zealous endpoint
        var key;
        var ix;
        if (data.address) {
            for (key in data.address) {
                if (!data.address[key]) {
                    delete data.address[key];
                }
            }
        }

        return $http.put(endpoint, data).then(function (response) {
            investorService.purgeCache('^investor$');
            return true;
        }, function (error) {
            return $q.reject({
                reason: 'gbGroup.error.unexpected'
            });
        });
    };

    /**
     * @ngdoc method
     * @name gbGroupService#submitKycSecondary
     *
     * @description
     * Submits secondary kyc data to the gbGroup service.
     *
     * @param {string} type
     * @param {object} data
     * @returns {Promise}
     */
    api.submitKycSecondary = function (data) {

        var endpoint = KYC_SECONDARY_ENDPOINT;

        return $http.put(endpoint, {
            documents: data
        }).then(function (response) {
            return true;
        }, function (error) {
            if (error.data === 'file.max-size-exceeded') {
                return $q.reject({
                    reason: 'gbGroup.error.max-size-exceeded'
                });
            }
            return $q.reject({
                reason: 'gbGroup.error.unexpected'
            });
        });
    };

    /**
     * Validates a postcode
     *
     * @param {string} postcode
     * @returns {boolean}
     */
    api.validatePostcode = function (postcode) {
        return POSTCODE_REGEXP.test(postcode);
    };

    /**
     * exposes the postcode regexp
     *
     * @property {string}
     */
    api.postCodeRegexp = POSTCODE_REGEXP;

    return api;
}]);
})(window, window.angular);